import { render } from "./DailySalesReport.vue?vue&type=template&id=12c771b8&scoped=true"
import script from "./DailySalesReport.vue?vue&type=script&lang=js"
export * from "./DailySalesReport.vue?vue&type=script&lang=js"

import "./DailySalesReport.vue?vue&type=style&index=0&id=12c771b8&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c771b8"]])

export default __exports__